<div class="modal-dialog hey-gen-prompt-creator">
  <div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="heygen-creator" [id]="dialogTitleId"></h4>
      <button type="button" class="close-btn" (click)="cancel()" aria-label="Cancel">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body" [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>Prompt Name: (To recognize by in list of prompts)</mat-label>
        <input type="text" matInput formControlName="promptName" />
        @if (form.controls.promptName.hasError('required')) {
          <mat-error>Field is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>AI Role</mat-label>
        <input type="text" matInput formControlName="aiRole" />
        @if (form.controls.aiRole.hasError('required')) {
          <mat-error>Field is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Human Role</mat-label>
        <input type="text" matInput formControlName="humanRole" />
        @if (form.controls.humanRole.hasError('required')) {
          <mat-error>Field is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Start Prompt</mat-label>
        <textarea type="text" matInput formControlName="startPrompt"></textarea>
        @if (form.controls.startPrompt.hasError('required')) {
          <mat-error>Field is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Main Prompt</mat-label>
        <textarea type="text" matInput formControlName="mainPrompt"></textarea>
        @if (form.controls.mainPrompt.hasError('required')) {
          <mat-error>Field is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Final Prompt</mat-label>
        <textarea type="text" matInput formControlName="finalPrompt"></textarea>
        @if (form.controls.finalPrompt.hasError('required')) {
          <mat-error>Field is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Context</mat-label>
        <textarea type="text" matInput formControlName="context"></textarea>
        @if (form.controls.context.hasError('required')) {
          <mat-error>Field is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="goreact-modal-footer">
      <button type="button" class="secondary-btn" (click)="cancel()" translate="common_cancel"></button>
      <button class="primary-btn" (click)="close()" translate="common_save" data-cy="common_save"></button>
    </div>
  </div>
</div>
